import type { Template } from "@/types";

export const PO_07_H3_V4: Template[] = [
    {
        id: "po-07-h3v4-01",
        name: "PO 01 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_01.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 42, y: 146, width: 512, height: 361, rotation: 0, imageRotation: 0 },
            { id: "2", x: 42, y: 515, width: 252, height: 188, rotation: 0, imageRotation: 0 },
            { id: "3", x: 302, y: 515, width: 252, height: 188, rotation: 0, imageRotation: 0 },
            { id: "4", x: 703, y: 147, width: 186, height: 275, rotation: 0, imageRotation: 0 },
            { id: "5", x: 703, y: 430, width: 186, height: 274, rotation: 0, imageRotation: 0 },
            { id: "6", x: 897, y: 147, width: 185, height: 275, rotation: 0, imageRotation: 0 },
            { id: "7", x: 897, y: 430, width: 185, height: 274, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-02",
        name: "PO 02 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_02.png",
        size: [1190, 850],
        style: {},
        slots: [           
            { id: "1", x: 59, y: 173, width: 192, height: 164, rotation: 0, imageRotation: 0 },
            { id: "2", x: 59, y: 345, width: 192, height: 163, rotation: 0, imageRotation: 0 },
            { id: "3", x: 59, y: 516, width: 192, height: 163, rotation: 0, imageRotation: 0 },
            { id: "4", x: 259, y: 173, width: 292, height: 506, rotation: 0, imageRotation: 0 },
            { id: "5", x: 641, y: 173, width: 325, height: 506, rotation: 0, imageRotation: 0 },
            { id: "6", x: 973, y: 173, width: 160, height: 249, rotation: 0, imageRotation: 0 },
            { id: "7", x: 973, y: 430, width: 160, height: 249, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-03",
        name: "PO 03 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_03.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 34, y: 135, width: 534, height: 376, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 34, y: 519, width: 263, height: 197, rotation: 0, imageRotation: 0 },
            { id: "3", x: 305, y: 519, width: 263, height: 197, rotation: 0, imageRotation: 0 },
            { id: "4", x: 620, y: 135, width: 399, height: 581, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1027, y: 135, width: 128, height: 188, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1027, y: 331, width: 128, height: 188, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1027, y: 527, width: 128, height: 188, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-04",
        name: "PO 04 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_04.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 128, y: 77, width: 340, height: 227, rotation: 0, imageRotation: 0 },
            { id: "2", x: 128, y: 312, width: 340, height: 227, rotation: 0, imageRotation: 0 },
            { id: "3", x: 128, y: 547, width: 340, height: 227, rotation: 0, imageRotation: 0 },
            { id: "4", x: 667, y: 77, width: 222, height: 345, rotation: 0, imageRotation: 0 },
            { id: "5", x: 667, y: 430, width: 222, height: 344, rotation: 0, imageRotation: 0 },
            { id: "6", x: 897, y: 77, width: 222, height: 345, rotation: 0, imageRotation: 0 },
            { id: "7", x: 897, y: 430, width: 222, height: 344, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-05",
        name: "PO 05 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_05.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 54, y: 153, width: 485, height: 359, rotation: 0, imageRotation: 0 },
            { id: "2", x: 54, y: 520, width: 239, height: 177, rotation: 0, imageRotation: 0 },
            { id: "3", x: 301, y: 520, width: 238, height: 177, rotation: 0, imageRotation: 0 },
            { id: "4", x: 718, y: 153, width: 171, height: 269, rotation: 0, imageRotation: 0 },
            { id: "5", x: 718, y: 430, width: 171, height: 268, rotation: 0, imageRotation: 0 },
            { id: "6", x: 897, y: 153, width: 171, height: 269, rotation: 0, imageRotation: 0 },
            { id: "7", x: 897, y: 430, width: 171, height: 268, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-06",
        name: "PO 06 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_06.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 83, y: 80, width: 430, height: 307, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 83, y: 395, width: 211, height: 146, rotation: 0, imageRotation: 0 },
            { id: "3", x: 302, y: 395, width: 211, height: 146, rotation: 0, imageRotation: 0 },
            { id: "4", x: 83, y: 549, width: 138, height: 221, rotation: 0, imageRotation: 0 },
            { id: "5", x: 229, y: 549, width: 138, height: 221, rotation: 0, imageRotation: 0 },
            { id: "6", x: 375, y: 549, width: 138, height: 221, rotation: 0, imageRotation: 0 },
            { id: "7", x: 678, y: 80, width: 430, height: 689, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-07",
        name: "PO 07 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_07.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 83, y: 234, width: 430, height: 307, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 83, y: 80, width: 211, height: 146, rotation: 0, imageRotation: 0 },
            { id: "3", x: 302, y: 80, width: 211, height: 146, rotation: 0, imageRotation: 0 },
            { id: "4", x: 83, y: 549, width: 138, height: 221, rotation: 0, imageRotation: 0 },
            { id: "5", x: 229, y: 549, width: 138, height: 221, rotation: 0, imageRotation: 0 },
            { id: "6", x: 375, y: 549, width: 138, height: 221, rotation: 0, imageRotation: 0 },
            { id: "7", x: 678, y: 80, width: 430, height: 689, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-08",
        name: "PO 08 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_08.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 201, width: 591, height: 448, rotation: 0, imageRotation: 0 },
            { id: "2", x: 599, y: 201, width: 292, height: 213, rotation: 0, imageRotation: 0 },
            { id: "3", x: 899, y: 201, width: 292, height: 213, rotation: 0, imageRotation: 0 },
            { id: "4", x: 599, y: 421, width: 142, height: 227, rotation: 0, imageRotation: 0 },
            { id: "5", x: 749, y: 421, width: 142, height: 227, rotation: 0, imageRotation: 0 },
            { id: "6", x: 899, y: 421, width: 142, height: 227, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1049, y: 421, width: 142, height: 227, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-09",
        name: "PO 09 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_09.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 218, width: 249, height: 413, rotation: 0, imageRotation: 0 },
            { id: "2", x: 257, y: 218, width: 164, height: 133, rotation: 0, imageRotation: 0 },
            { id: "3", x: 257, y: 359, width: 164, height: 132, rotation: 0, imageRotation: 0 },
            { id: "4", x: 257, y: 499, width: 164, height: 132, rotation: 0, imageRotation: 0 },
            { id: "5", x: 429, y: 218, width: 249, height: 413, rotation: 0, imageRotation: 0 },
            { id: "6", x: 686, y: 218, width: 249, height: 413, rotation: 0, imageRotation: 0 },
            { id: "7", x: 943, y: 218, width: 248, height: 413, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-10",
        name: "PO 10 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_10.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 223, width: 243, height: 405, rotation: 0, imageRotation: 0 },
            { id: "2", x: 251, y: 223, width: 243, height: 405, rotation: 0, imageRotation: 0 },
            { id: "3", x: 502, y: 223, width: 243, height: 405, rotation: 0, imageRotation: 0 },
            { id: "4", x: 753, y: 223, width: 243, height: 405, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1004, y: 222, width: 188, height: 130, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1004, y: 360, width: 188, height: 130, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1004, y: 498, width: 188, height: 129, rotation: 0, imageRotation: 0 }
        ],
    }
];